import { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import API from "../lib/api";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [status, setStatus] = useState("checking");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    const poll = async () => {
      try {
        const { data } = await API.get(`/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.payment_status === "expired" || data.status === "expired") { setStatus("failed"); return; }
        if (attempts < 10) { setTimeout(() => setAttempts(a => a + 1), 2000); }
        else { setStatus("failed"); }
      } catch {
        if (attempts < 10) { setTimeout(() => setAttempts(a => a + 1), 2000); }
        else { setStatus("failed"); }
      }
    };
    poll();
  }, [sessionId, attempts]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F0F0F0] flex items-center justify-center px-6" data-testid="payment-success-page">
      <div className="text-center max-w-md">
        {status === "checking" && (
          <>
            <Loader2 size={48} className="mx-auto mb-6 text-[#00FF41] animate-spin" />
            <h1 className="font-heading text-2xl font-bold tracking-tight mb-2" data-testid="payment-checking">Processing Payment</h1>
            <p className="text-sm text-slate-500">Please wait while we confirm your payment...</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle size={48} className="mx-auto mb-6 text-[#00FF41]" />
            <h1 className="font-heading text-2xl font-bold tracking-tight mb-2" data-testid="payment-success">Payment Successful!</h1>
            <p className="text-sm text-slate-400 mb-8">Your tool has been activated. You can access it from your dashboard.</p>
            <Link to="/dashboard" className="inline-flex items-center gap-2 bg-[#00FF41] text-[#0A0A0A] px-6 py-3 text-sm font-bold hover:bg-[#00CC33] transition-colors" data-testid="payment-go-dashboard">
              Go to Dashboard
            </Link>
          </>
        )}
        {status === "failed" && (
          <>
            <XCircle size={48} className="mx-auto mb-6 text-red-500" />
            <h1 className="font-heading text-2xl font-bold tracking-tight mb-2" data-testid="payment-failed">Payment Issue</h1>
            <p className="text-sm text-slate-400 mb-8">There was an issue with your payment. Please try again or contact support.</p>
            <Link to="/#pricing" className="inline-flex items-center gap-2 bg-[#00FF41] text-[#0A0A0A] px-6 py-3 text-sm font-bold hover:bg-[#00CC33] transition-colors" data-testid="payment-try-again">
              Try Again
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
